import { apiClient } from './client';

export interface PalaceStatus {
  index: number;
  name: string;
  topic: string;
  query_count: number;
  explored: boolean;
  recommended_question_id: string;
  recommended_question_text: string;
}

export interface ExploredPalacesResponse {
  success: boolean;
  palaces: PalaceStatus[];
  explored_count: number;
  total_palaces: number;
}

export const getExploredPalaces = async (): Promise<ExploredPalacesResponse> => {
  const response = await apiClient.get<ExploredPalacesResponse>('/api/user/explored-palaces');
  return response as any as ExploredPalacesResponse;
};
